import React from 'react';
import _ from 'lodash';

interface WaiverViewFieldProps {
  condition?: boolean;
  value: any;
  large?: boolean;
  label: string;
}

class WaiverViewField extends React.Component<WaiverViewFieldProps> {
  showField() {
    const { condition, value } = this.props;
    return _.isBoolean(condition) ? condition : !_.isEmpty(value);
  }

  fieldClass() {
    return this.props.large ? 'waiver-data-large' : 'waiver-data';
  }

  wrapperClass() {
    return this.props.large ? 'text-area' : '';
  }

  render() {
    const { label, value } = this.props;
    return (
      this.showField() && (
        <div className={`form-group ${this.wrapperClass()}`}>
          <label>{label}:</label>
          <div className={`form-control ${this.fieldClass()}`}>{value}</div>
        </div>
      )
    );
  }
}

export default WaiverViewField;